import React from 'react';
import MarkerIcon from "./marker.svg.js";
import styles from "./styles.module.css.js";
export var MapMarkerSpinner = _ref => {
  var {
    size
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.spinner,
    style: {
      '--size': size
    }
  }, /*#__PURE__*/React.createElement(MarkerIcon, {
    className: styles.marker
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.wave
  }));
};
export default MapMarkerSpinner;
//# sourceMappingURL=index.js.map